/**
 * @packageDocumentation
 * @module dom/model
 */

export interface Destroy {
  /**
   * remove all children from element
   */
  (el: Element): void;
}

/**
 * { @link Destroy }
 */
export default (el: Element) => {
  el.remove();
};
